import React, { Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import { isNullOrUndefined } from '../../../util/objects';
import { stringIsNullOrEmpty } from '../../../util/strings';
import Separator from './Separator';
import { orientationMode } from '../../../util/objects';
import Typography from '../../../component/Typography';
import Inline from './Inline';

const ViewHeader = ({ children, title, subtitle, variant, className }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `view-header--${variant}`;

    return (
        <div className={`view-header ${cssVariant || ''} ${className || ''}`}>
            <Inline className="header">
                <Typography className="title" variant="display4">
                    {title}
                </Typography>
                {!stringIsNullOrEmpty(subtitle) && (
                    <Fragment>
                        <div>
                            <Separator orientation={orientationMode.vertical} />
                        </div>
                        <Typography className="subtitle" variant="h1">
                            {subtitle}
                        </Typography>
                    </Fragment>
                )}
            </Inline>
            {!isNullOrUndefined(children) && <div className="header-children">{children}</div>}
        </div>
    );
};

export default withStyles({})(ViewHeader);
